<template lang="pug">
.container.grid-xl
  .card.mt-2
    .card-header
      .text-bold Filtrar
    .card-body
      form-filter(@submit="fetchReport")
  .full-height.loading.loading-lg(v-if="loading")
  div(v-else)
    .card.my-2
      .card-header
        .h5 Tabela resumo de análises por situação
      .card-body
        table.table.table-striped.table-responsive
          thead
            tr
              th {{ 'analise.situacao' | tModel }}
              th.text-right Quantidade
          tbody
            tr(v-for="row in report")
              td {{ `enums.db.enum_ordem_servico_analise_situacao.${row.situacao}` | translate }}
              td.text-right {{ row.q }}
</template>

<script>
import analises from "@/api/indicadores/analises"
import FormFilter from "./components/Filter.vue"

export default {
  data() {
    return {
      report: null,
      loading: false,
    }
  },
  components: { FormFilter },
  methods: {
    async fetchReport(q = {}) {
      try {
        this.loading = true
        this.report = await analises.situacoes({ q })
      } catch (error) {
        toastErrors(error)
      } finally {
        this.loading = false
      }
    },
  },
  created() {
    this.fetchReport()
  },
}
</script>
